"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeddyAuctionHouse__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "teddyId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "extended",
                type: "bool",
            },
            {
                indexed: false,
                internalType: "string",
                name: "charityName",
                type: "string",
            },
            {
                indexed: false,
                internalType: "string",
                name: "donorName",
                type: "string",
            },
        ],
        name: "AuctionBid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "teddyId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startTime",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
        ],
        name: "AuctionCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "teddyId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
        ],
        name: "AuctionExtended",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "minBidIncrementPercentage",
                type: "uint256",
            },
        ],
        name: "AuctionMinBidIncrementPercentageUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "officialAuctionEndTime",
                type: "uint256",
            },
        ],
        name: "AuctionOfficialEndTimeUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "reservePrice",
                type: "uint256",
            },
        ],
        name: "AuctionReservePriceUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "teddyId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "winner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "charityName",
                type: "string",
            },
            {
                indexed: false,
                internalType: "string",
                name: "donorName",
                type: "string",
            },
        ],
        name: "AuctionSettled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "timeBuffer",
                type: "uint256",
            },
        ],
        name: "AuctionTimeBufferUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "isNextAuctionCustomTeddy",
                type: "bool",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "headAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "bodyAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "face",
                        type: "uint48",
                    },
                ],
                indexed: false,
                internalType: "struct ITeddySeeder.Seed",
                name: "customTeddySeed",
                type: "tuple",
            },
        ],
        name: "CustomTeddyForNextAuctionUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [],
        name: "auction",
        outputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "teddyId",
                type: "uint128",
            },
            {
                internalType: "uint64",
                name: "startTime",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "endTime",
                type: "uint64",
            },
            {
                internalType: "address payable",
                name: "bidder",
                type: "address",
            },
            {
                internalType: "bool",
                name: "settled",
                type: "bool",
            },
            {
                internalType: "string",
                name: "charityName",
                type: "string",
            },
            {
                internalType: "string",
                name: "donorName",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "teddyId",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "charityName",
                type: "string",
            },
            {
                internalType: "string",
                name: "donorName",
                type: "string",
            },
        ],
        name: "createBid",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "customTeddySeed",
        outputs: [
            {
                internalType: "uint48",
                name: "background",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "body",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "headAccessory",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "bodyAccessory",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "face",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "duration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ITeddyToken",
                name: "_teddy",
                type: "address",
            },
            {
                internalType: "address",
                name: "_weth",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_timeBuffer",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_reservePrice",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "_minBidIncrementPercentage",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "_duration",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_officialAuctionEndTime",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "_isNextAuctionCustomTeddy",
                type: "bool",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "headAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "bodyAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "face",
                        type: "uint48",
                    },
                ],
                internalType: "struct ITeddySeeder.Seed",
                name: "_customTeddySeed",
                type: "tuple",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "isNextAuctionCustomTeddy",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minBidIncrementPercentage",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "officialAuctionEndTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "reservePrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "_isNextAuctionCustomTeddy",
                type: "bool",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "headAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "bodyAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "face",
                        type: "uint48",
                    },
                ],
                internalType: "struct ITeddySeeder.Seed",
                name: "_customTeddySeed",
                type: "tuple",
            },
        ],
        name: "setCustomTeddyForNextAuction",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_minBidIncrementPercentage",
                type: "uint8",
            },
        ],
        name: "setMinBidIncrementPercentage",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_officialAuctionEndTime",
                type: "uint256",
            },
        ],
        name: "setOfficialAuctionEndTime",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_reservePrice",
                type: "uint256",
            },
        ],
        name: "setReservePrice",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_timeBuffer",
                type: "uint256",
            },
        ],
        name: "setTimeBuffer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settleAuction",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settleCurrentAndCreateNewAuction",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "teddy",
        outputs: [
            {
                internalType: "contract ITeddyToken",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "timeBuffer",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "weth",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class TeddyAuctionHouse__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TeddyAuctionHouse__factory = TeddyAuctionHouse__factory;
TeddyAuctionHouse__factory.bytecode = _bytecode;
TeddyAuctionHouse__factory.abi = _abi;
